import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn:
      "https://f9529b4d5e724f3dac602bb246ece073@o455914.ingest.sentry.io/5448201",
    release: "my-project-name@" + process.env.npm_package_version, // To set your release version
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.5 // We recommend adjusting this in production
  });
}

// import { flare } from "@flareapp/flare-client";
// if (process.env.NODE_ENV === "production") {
//   flare.light(process.env.FLARE_PUBLIC);
// }

import "alpinejs";

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// import Vue from 'vue/dist/vue'
// window.Vue = Vue;
//
// if (document.getElementById("vue-wrap")) {
//     Vue.component(
//       "avatar-upload",
//       require("./components/AvatarUpload.vue").default
//     );
//   new Vue({
//     el: "#vue-wrap"
//   });
// }
